import { useProperties } from '@/api/hooks';
import { PropertyLotsPanel } from '@/components/features/lots/PropertyLotsPanel';
import { Badge } from '@/components/ui/Badge';
import { Card, CardBody } from '@/components/ui/Card';
import { usePropertyScope } from '@/contexts/PropertyContext';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

const ACTIVITY_LABELS: Record<string, string> = {
  breeding: 'Cria / reprodução',
  fattening: 'Engorda',
  dairy: 'Leite',
  rearing: 'Recria',
  feedlot: 'Confinamento',
};

export function PropertyDetailPage() {
  const { id } = useParams();
  const propertyId = Number(id);
  const { setPropertyId } = usePropertyScope();
  const { data, isLoading } = useProperties();

  const property = data?.properties.find((p) => p.id === propertyId);

  useEffect(() => {
    if (propertyId > 0) setPropertyId(propertyId);
  }, [propertyId, setPropertyId]);

  if (isLoading) {
    return <div className="h-48 rounded-2xl bg-manejai-sand/40 animate-pulse" />;
  }

  if (!property) {
    return (
      <div>
        <Link to="/propriedades" className="inline-flex items-center gap-1 text-sm text-manejai-moss hover:underline mb-4">
          <ArrowLeft className="h-4 w-4" /> Voltar às fazendas
        </Link>
        <p className="text-manejai-bark/70">Fazenda não encontrada.</p>
      </div>
    );
  }

  return (
    <div>
      <Link
        to="/propriedades"
        className="inline-flex items-center gap-1 text-sm text-manejai-moss hover:underline mb-4"
      >
        <ArrowLeft className="h-4 w-4" /> Fazendas
      </Link>

      <h1 className="page-title">{property.name}</h1>
      <p className="page-subtitle">
        {[property.city, property.state_code].filter(Boolean).join(' — ') || 'Local não informado'}
      </p>

      <Card className="mt-6">
        <CardBody className="flex flex-wrap gap-2">
          {property.activities.map((a) => (
            <Badge key={a} tone="info">
              {ACTIVITY_LABELS[a] ?? a}
            </Badge>
          ))}
        </CardBody>
      </Card>

      <PropertyLotsPanel propertyId={property.id} propertyName={property.name} />
    </div>
  );
}
